import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { Flex, Loading, Text } from "@paguelofacil/pf-components";

import { STEPS } from "../services/utils/Constants";
import { language, languageDefault } from "../services/utils/Language";
import { getSessionCryptofacil, getUserCryptofacil } from "../services/utils/StorageUtils";

import { HeaderPayment } from "../components/HeaderPayment";
import { ButtonBack } from "../components/ButtonBack";
import ValidateCode from "../components/ValidateCode";
import SignupForm from "../components/SignupForm";
import AppWithErrorBoundary from "../components/Error/ErrorBoudary";

import "../assets/scss/containers.scss";

const Signup = ({ intl }) => {
    const navigate = useNavigate();
    const [step, setStep] = useState(STEPS.CREATE_ACCOUNT);
    const [isLoading, setIsLoading] = useState(false);
    const [valuesForm, setValuesForm] = useState({
        name: "",
        phone: "",
        email: "",
        validationCode: "",
    });

    const handleChangeForm = (nameInput, value) => {
        setValuesForm({
            ...valuesForm,
            [nameInput]: value,
        });
    };

    useEffect(() => {
        const sessionCryptofacil = getSessionCryptofacil();
        const userCryptofacil = getUserCryptofacil();

        if (sessionCryptofacil && userCryptofacil) {
            return navigate("/cryptofacil/home");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AppWithErrorBoundary>
            <Loading isLoading={isLoading}>
                <Flex direction="column" width="auto" minW="auto" className="container-payment">
                    <HeaderPayment
                        title={
                            STEPS.CREATE_ACCOUNT === step ? (
                                <FormattedMessage
                                    id={language.title_signup}
                                    defaultMessage={languageDefault.title_signup}
                                />
                            ) : (
                                <FormattedMessage
                                    id={language.title_signup_validation_code}
                                    defaultMessage={languageDefault.title_signup_validation_code}
                                />
                            )
                        }
                    />
                    <Flex gap="0" wrap="nowrap">
                        <ButtonBack handleBack={() => navigate("/")} />
                        <Text variant="caption" weight="regular">
                            {STEPS.CREATE_ACCOUNT === step ? (
                                <FormattedMessage
                                    id={language.subtitle_signup}
                                    defaultMessage={languageDefault.subtitle_signup}
                                />
                            ) : (
                                <>
                                    <FormattedMessage
                                        id={language.subtitle_signup_validation_code}
                                        defaultMessage={languageDefault.subtitle_signup_validation_code}
                                    />
                                    &nbsp;
                                    {valuesForm.email}
                                </>
                            )}
                        </Text>
                    </Flex>
                    {STEPS.CREATE_ACCOUNT === step && (
                        <SignupForm
                            intl={intl}
                            handleChangeForm={handleChangeForm}
                            setIsLoading={setIsLoading}
                            valuesForm={valuesForm}
                            setStep={setStep}
                        />
                    )}
                    {STEPS.VALIDATE_CODE === step && (
                        <ValidateCode
                            intl={intl}
                            setIsLoading={setIsLoading}
                            handleChangeForm={handleChangeForm}
                            valuesForm={valuesForm}
                        />
                    )}
                </Flex>
            </Loading>
        </AppWithErrorBoundary>
    );
};

const SignupDecorate = injectIntl(Signup);

export default SignupDecorate;
